export enum DashboardRoutePath {
  CREATE_PUZZLE = 'create-puzzle',
  CREATE_COLLECTION = 'create-categories',
  CREATE_ARTISTS = 'create-artist',
  CREATE_GAME_EVENTS = 'create-game-events',
  APPROVE_PUZZLES = 'approve-puzzles',
  ARTISTS = 'artists',
  PUZZLES = 'puzzles',
  COLLECTIONS = 'categories',
  COLORING_GRID_COLLECTIONS = 'coloring-grid-categories',
  // ANALYTICS = 'analytics',
  GAME_EVENTS = 'game-events',
  STORIES = 'stories',
  SETTINGS = 'settings',
  ACCOUNT_INFO = 'account-info',
  USERS = 'users',
  EDIT_PUZZLE = 'edit-puzzle',
  EDIT_GAME_EVENTS = 'edit-game-event',
  VIEW_ARTIST = 'view-artist',
  EDIT_ARTIST = 'edit-artist',
  PAYOUTS = 'payouts',
  VIEW_PUZZLE = 'view-puzzle',
  INSIGHTS = 'insights',
  INSIGHT_DETAILS = 'insights-details',
  ARTIST_INSIGHTS = 'artist-insights',
  REVENUE = 'revenue',
  PUZZLE_REVENUE = 'puzzle-revenue',
  ARTIST_REVENUE = 'artist-revenue',
  REVENUE_BY_PUZZLE = 'revenue-by-puzzle',
  REVENUE_BY_ARTIST = 'revenue-by-artist',
  PAYOUT_REQUESTS = 'payout-requests',
  REVENUE_ANALYTICS = 'revenue-analytics',
  DAILY_PUZZLES = 'daily-puzzles',
  FIRST_APPROVAL = 'first-approval',
  MANAGE_VIDEO_PUZZLE = 'manage-video-puzzle',
  MANAGE_STORY = 'manage-story',
  MANAGE_COLORING_GRIDS = 'manage-coloring-grids',
  VIEW_COLORING_GRIDS = 'view-coloring-grid',
  COLORING_GRIDS = 'coloring-grids',
  CONTENT_PREVIEW_SCREEN = 'preview',
  SUBSCRIPTIONS_SPLIT = 'subscriptions-split',
  THEMES = 'themes',
  MANAGE_THEME = 'manage-theme',
}
